import React, { useEffect, useRef, useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import './auth.css';

interface UserMenuProps {
  username: string;
  role: string;
  onChangePassword: () => void;
  onLogout: () => void;
}

export function UserMenu({ username, role, onChangePassword, onLogout }: UserMenuProps) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="user-menu" ref={menuRef}>
      <button
        type="button"
        className="user-menu-trigger"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-haspopup="true"
      >
        <span className="user-menu-name">{username}</span>
        <span className="user-menu-role">{role}</span>
        <ArrowDropDownIcon className={open ? 'user-menu-chevron open' : 'user-menu-chevron'} />
      </button>
      {open && (
        <div className="user-menu-dropdown">
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              onChangePassword();
            }}
          >
            Change password
          </button>
          <button
            type="button"
            className="user-menu-logout"
            onClick={() => {
              setOpen(false);
              onLogout();
            }}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
}
